import store from "../../../store";


export default async function fillStorePrice(snap) {
	
	const sku = snap.selectedVariantSKU
	const variant = snap.variants.find(variant => variant.sku === sku);
	
	
	
	const basePrice = Number(parseFloat((variant.price != null ? variant.price : "0").toString().replace(/,/g, '')))
	
	store.order = {
		...snap.order,
		basePrice: basePrice.toFixed(2),
		variant_id: variant.id,
		product_id: variant.store_product_id,
	}
	return basePrice;
}